import React, { useMemo } from "react";
import { useGetHtmlApiQuery } from "../../redux/services/apiHome";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { getDateUpdate } from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { getLastUpdatedOn } from "../../Utils/apiFunctions";

const PowerPotentialPage = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: powerPotentialData = {}, isLoading: powerPotentialIsLoading } =
    useGetHtmlApiQuery({ url: 92, lang: languageType });

  const pageBody =
    powerPotentialData?.body?.[0]?.value ?? "No content available";

  const { data: lastUpdatedOnData = [], isLoading: lastUpdatedIsLoading } =
    useGetProtectedApiDataQuery({
      url: "basic_page",
      lang: languageType,
    });

  const lastUpdatedOn = useMemo(
    () => getLastUpdatedOn(lastUpdatedOnData, 92),
    [lastUpdatedOnData]
  );

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (powerPotentialIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Power Generation", "विद्युत उत्पादन")}
        titleLink="/power-generation"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12"></div>
          </div>

          <div className="container power-section ">
            <div>
              <div dangerouslySetInnerHTML={{ __html: pageBody }} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PowerPotentialPage;
